<template>
  <div
    class="prompt-container"
    v-if="login.show"
    @touchmove.prevent
  >
    <div class="prompt" />
    <div class="login-box-container">
      <div class="header-close-box">
        <i
          class="icon"
          @click="cancel"
        />
      </div>
      <p
        class="header"
        :class="{'center': !isWx}"
      >
        {{ heardTxt }}
      </p>
      <div class="input-content">
        <i class="icon phone" />
        <input
          type="tel"
          maxlength="11"
          placeholder="手机号码"
          class="ipt"
          name="mobile"
          v-model="mobile"
          @blur="blurInput"
          @input="numInput('mobile')"
          :disabled="times < 61"
        />
      </div>
      <div
        class="input-content"
        v-if="showValid"
      >
        <i class="icon vaild" />
        <input
          type="text"
          maxlength="4"
          placeholder="图形验证码"
          class="ipt"
          v-model="validCode"
          @blur="blurInput"
          @input="validCodeInput"
          name="validCode"
        />
        <img
          class="valid-code"
          :src="`${validApi}?key=${validKey}`"
          @click="getValidCode"
        />
      </div>
      <div class="input-content">
        <i class="icon verify" />
        <input
          type="tel"
          maxlength="6"
          placeholder="短信验证码"
          class="ipt"
          name="smsCode"
          v-model="smsCode"
          @blur="blurInput"
          @input="numInput('sms')"
        />
        <span
          class="get-code-btn"
          v-if="times > 60"
          @click="getMessageCode"
        >获取验证码</span>
        <span
          class="get-code-btn time"
          v-if="times < 61"
        >{{ times }}S倒计时</span>
      </div>
      <div class="btns">
        <button
          class="btn"
          :disabled="!disabled"
          @click="authLogin"
        >
          {{ btnTxt }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import { Api } from '../api/'
  import config from '../config/'
  import { sendSmsCode, authLogin } from '../services/'
  import { setStorageCache, getSessionCache } from '../utils'
  export default {
    name: 'login',
    props: {
      login: {
        type: Object,
        default (){
          return {}
        }
      }
    },
    data () {
      return {
        times: 61,
        messageValue: '', // 用户输入验证码
        validApi: Api.captcah, // 图形验证码接口
        validKey: Date.parse(new Date()).toString(), // 图形验证码随机key
        validCode: '', // 图形验证码输入input值
        mobile: '', // 手机号码
        smsCode: '', // 短信验证码
        showValid: false, // 是否展示图形验证
        timeFn: false, // 时间方法
        heardTxt: '',
        btnTxt: ''
      }
    },
    computed: {
      ...mapGetters({
        client: 'client' // 客户端信息
      }),
      mobileState () {
        return /^[1][3456789]\d{9}$/.test(this.mobile)
      },
      disabled () {
        if (this.mobileState && this.smsCode.length === 6) {
          if (this.showValid) {
            if (this.validCode.length === 4) {
              return true
            } else {
              return false
            }
          } else {
            return true
          }
        } else {
          return false
        }
      }
      , isWx(){
        return this.client.env === 'wx' && config.wxUrl
      }
    },
    mounted () {
      if (this.isWx) {
        this.heardTxt = '为了你的账号安全，请验证手机'
        this.btnTxt = '验证'
      } else {
        this.heardTxt = '注册/登录'
        this.btnTxt = '注册/登录'
      }
    },
    methods: {
      // 过滤图形验证码
      validCodeInput () {
        this.validCode = this.validCode.replace(/[^A-Za-z0-9]/g, '')
      },
      // 过滤手机号码
      numInput (type) {
        if (type === 'mobile') {
          this.mobile = this.mobile.replace(/[^0-9]/g, '')
        } else {
          this.smsCode = this.smsCode.replace(/[^0-9]/g, '')
        }
      },
      blurInput () { // 解决ios上键盘弹起后关闭光盘导致input焦点偏移问题
        setTimeout(() => {
          window.scrollTo(0, scroll)
        }, 100)
      },
      getMessageCode () { // 获取短信验证码
        if (!this.mobileState) {
          this.$toast('请输入正确的手机号码')
          return false
        } else if (this.showValid && this.validCode.length !== 4) {
          this.$toast('请输入图形验证码')
          return false
        }
        this.$toast('正在请求下发短信中...')
        sendSmsCode({
          phonenum: this.mobile,
          key: this.validKey,
          validCode: this.validCode
        })
          .then(res => {
            let {data} = res
            if (data.success) {
              this.timer()
              this.$toast('短信验证码已下发，请查收')
            } else {
              this.$toast(data.message)
              this.showValid = true
              this.getValidCode()
            }
          })
          .catch(() => {
            this.$toast('短信验证码下发失败，请稍后重试')
          })
      },
      getValidCode () { // 获取输入验证码图像的key
        let timeString = Date.parse(new Date()).toString()
        let _validCodeKey = timeString + timeString + '000000'
        this.validCode = ''
        this.validKey = _validCodeKey
      },
      authLogin () { // 一键注册登录
        let _this = this
        if (!_this.disabled) {
          return false
        }
        let params = {
          mobile: _this.mobile, // 手机号码
          extendInfo: {
            extendType: 'SMS',
            // 短信组件id
            modelid: config.modelId,
            // 短信模板id
            templateid: config.templateId,
            // 短信验证码
            smsValiCode: _this.smsCode
          }
        }
        if (this.isWx) { // 是在微信公众号上
          let authTokenByTicket = getSessionCache('authTokenByTicket')
          if (authTokenByTicket && authTokenByTicket.unionId) {
            params.extendInfo.extendType = 'WXMINI'
            params.extendInfo.uniqueId = authTokenByTicket.unionId
            params.extendInfo.bindType = config.bindType
            params.loginType = 4
          }
        }
        authLogin(params)
          .then(res => {
            let { data } = res
            if (data.success) { // 绑定成功
              const userInfo = { token: data.valueObject.authToken, userID: data.valueObject.exjf.userId, phoneNum: _this.mobile}
              setStorageCache('cacheUser', userInfo)
              this.$store.dispatch('updateUserInfo', { data: userInfo })
              _this.$emit('loginState', {type: _this.login.type})
            } else if (data.code === '503') { // 短信验证码校验失败,请重新输入
              this.getValidCode()
              this.$toast('短信验证码校验失败,请重新输入')
            } else { // 该手机号码已被其他账号绑定
              this.getValidCode()
              this.$toast(data.message)
            }
          })
          .catch(() => { // 绑定失败，请稍后重试
            this.$toast('登录失败，请稍后重试')
          })
      },
      timer () { // 倒计时
        let times = this.times
        if (times < 1) {
          this.times = 61
          return
        }
        if (this.timeFn) {
          clearTimeout(this.timeFn)
        }
        this.timeFn = setTimeout(() => {
          this.times = this.times - 1
          this.timer()
        }, 1000)
      },
      cancel () {
        this.$emit('cancel', {type: this.login.type})
      },
      confirm () {
        this.$emit('confirm', {type: this.login.type})
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/common.scss";
  .prompt-container {
    .login-box-container {
      @extend %dialog-content;
      padding: 20px 0 98px;
      .header-close-box{
        display: flex;
        justify-content: flex-end;
        .icon{
          background: url("../assets/image/close2.png") no-repeat;
          background-size: 39px;
          background-position: center;
          width: 100px;
          height: 100px;
          display: flex;
          text-align: right;
          z-index: 2;
        }
      }
      .header{
        font-size: 45px;
        letter-spacing: 1PX;
        color: #666666;
        text-align: left;
        margin-left: 30px;
        &.center{
          text-align: center;
          margin-left: 0px
        }
      }
      .input-content{
        position: relative;
        margin: 0 96px;
        height: 162px;
        .icon{
          position: absolute;
          top: 50%;
          left: 0px;
          background-repeat: no-repeat;
          background-size: contain;
          display: block;
          transform: translate(0, -50%);
          &.phone{
            background-image: url("../assets/image/icon_phone.png");
            width: 34px;
            height: 42px;
          }
          &.verify{
            background-image: url("../assets/image/icon_verify.png");
            width: 40px;
            height: 40px;
          }
          &.vaild{
            background-image: url("../assets/image/icon-valid.png");
            width: 33px;
            height: 39px;
          }
        }
        .ipt{
          width: 100%;
          height: 100%;
          padding-left: 50px;
          font-size: 54px;
          border-bottom: solid 1PX #eaeaea; /*no*/
          color: #010101;
          &:disabled{
            background-color: #fff;
            color: #bbb;
          }
        }
        .valid-code {
          width: 226px;
          height: 100px;
          position: absolute;
          right: 0px;
          top: 50%;
          margin-top: -50px;
          z-index: 2;
        }
        .get-code-btn{
          position: absolute;
          top: 0;
          right: 0;
          font-size: 45px;
          color: #f5bf39;
          height: 100%;
          @extend %flex-center-center;
          z-index: 2;
          &.time{
            color: #bbb;
          }
        }
      }
      .btns{
        margin: 95px 0 0px;
        .btn{
          width: 667px;
          height: 108px;
          @extend %btnsColor;
          border-radius: 54px;
          border: none;
          font-size: 45px;
          color: #000000;
          &:disabled {
            color: #999;
            background: none;
            background-color: #e6e6e6;
          }
        }
      }
      .tip{
        color: red;
      }
    }
  }
</style>
